module.exports = __webpack_public_path__ + "static/media/delete.383c69e8.svg";